import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import Layout from '../components/Layout';
import Dashboard from '../pages/Dashboard';
import Tasks from '../pages/Tasks';
import Events from '../pages/Events';
import EventPlanner from '../pages/EventPlanner';
import Calendar from '../pages/Calendar';
import GanttChart from '../pages/GanttChart';
import Callback from '../pages/Callback';
import UserDrillDown from '../pages/UserDrillDown';
import DivisionDashboard from '../pages/DivisionDashboard';
import DGAnalyticsDashboard from '../pages/DGAnalyticsDashboard';
import Faculty from '../pages/Faculty';
import CoordinatorTeams from '../pages/CoordinatorTeams';

import LoginScreen from '../components/LoginScreen';
import LoadingScreen from '../components/LoadingScreen';

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, loading } = useAuth();

    if (loading) return <LoadingScreen />;

    if (!isAuthenticated) return <Navigate to="/login" replace />;

    return children;
};

const LoginRoute = () => {
    const { isAuthenticated, loading } = useAuth();

    if (loading) return <LoadingScreen />;
    if (isAuthenticated) return <Navigate to="/" replace />;

    return <LoginScreen />;
};

const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/login" element={<LoginRoute />} />
            <Route path="/callback" element={<Callback />} />

            {/* Protected Routes */}
            <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                <Route index element={<Dashboard />} />
                <Route path="tasks" element={<Tasks />} />
                <Route path="events" element={<Events />} />
                <Route path="event-planner" element={<EventPlanner />} />
                <Route path="calendar" element={<Calendar />} />
                <Route path="gantt" element={<GanttChart />} />
                <Route path="dg/users" element={<UserDrillDown />} />
                <Route path="dg/analytics" element={<DGAnalyticsDashboard />} />
                <Route path="division/:divisionId" element={<DivisionDashboard />} />
                <Route path="faculty" element={<Faculty />} />
                <Route path="coordinator/team" element={<CoordinatorTeams />} />

            </Route>
        </Routes>
    );
};

export default AppRoutes;
